import type { IconProps } from '@magicschool/spellbook/components/Icon';
import { Icon } from '@magicschool/spellbook/components/Icon';
import type { FC } from 'react';

export type StatusIconProps = IconProps & {
  status?: 'primary' | 'success' | 'info' | 'warning' | 'error';
  size?: IconProps['size'];
};

export const StatusIcon: FC<StatusIconProps> = ({ status = 'primary', size = 'sm', ...props }) => {
  let name: IconProps['name'] = 'sparkles';

  switch (status) {
    case 'success':
      name = 'circle-check';
      break;
    case 'info':
      name = 'info';
      break;
    case 'warning':
      name = 'circle-alert';
      break;
    case 'error':
      name = 'ban';
      break;
  }

  return <Icon color={status as IconProps['color']} name={name} size={size} {...props} />;
};
